import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { observer } from 'mobx-react'
import {
  BigButton,
  Card,
  CardButton,
  ContentWrapper,
  Flex,
  Grid,
  H6,
  Lists,
  Spacer,
} from '~/components/elements'
import {
  AddOutlineIcon,
  ArrowForwardIosOutlineIcon,
  MailOutlineIcon,
  SupportAgentOutlineIcon,
} from '~/components/icons'
import { useRootStore } from '~/store/RootStore'
import { Constants } from '~/utils/Constants'

export const SupportPage = observer(() => {
  const navigate = useNavigate()
  const { account } = useRootStore()
  const currentService = account.getCurrentService

  return (
    <ContentWrapper>
      <Grid placeitems="start stretch" columns="1fr 1fr" gap="24px">
        <div>
          <H6>Support Options</H6>
          <Card padding="0">
            <Lists
              items={[
                {
                  key: '1',
                  icon: <SupportAgentOutlineIcon />,
                  text: (
                    <a
                      href={`tel:${Constants.WHOLESALERSETTINGS.contactSupport.replaceAll(' ', '')}`}
                    >
                      {Constants.WHOLESALERSETTINGS.contactSupport}
                    </a>
                  ),
                },
                {
                  key: '2',
                  icon: <MailOutlineIcon />,
                  text: (
                    <a
                      href={Constants.WHOLESALERSETTINGS.links.contactUs}
                      target="_blank"
                    >
                      Contact us
                    </a>
                  ),
                },
              ]}
            />
          </Card>
        </div>
        <div>
          <H6>Policies & Documents</H6>
          <Card padding="0">
            <Lists
              items={[
                {
                  key: '1',
                  text: (
                    <a
                      href={
                        Constants.WHOLESALERSETTINGS.links.financialHardship
                      }
                      target="_blank"
                    >
                      Financial Hardship Policy
                    </a>
                  ),
                },
                {
                  key: '2',
                  text: (
                    <a
                      href={
                        Constants.WHOLESALERSETTINGS.links
                          .complaintsHandlingPolicy
                      }
                      target="_blank"
                    >
                      Complaints Handling Policy
                    </a>
                  ),
                },
              ]}
            />
          </Card>
        </div>
      </Grid>
      <Spacer height="24px" />
      <Flex alignitems="flex-start" justifycontent="center">
        {/* <Button variant="secondary">Create New Support Ticket</Button>
        <Button variant="secondary">Make a Complaint</Button> */}

        <BigButton onClick={() => navigate({ to: '/support/new-complaint' })}>
          <AddOutlineIcon />
          <span>Make a Complaint</span>
        </BigButton>

        {currentService && currentService.type !== 'Voip' && (
          <BigButton onClick={() => navigate({ to: '/support/report-fault' })}>
            <AddOutlineIcon />
            <span>Report a Fault</span>
          </BigButton>
        )}
      </Flex>

      {Constants.WHOLESALERSETTINGS.code === 'OE' && (
        <>
          <Spacer height="24px" />

          <H6>Outages</H6>
          <CardButton
            onClick={() => navigate({ to: '/home/outages' })}
            style={{ marginBottom: '12px' }}
          >
            <span>Outages</span>
            <ArrowForwardIosOutlineIcon width="18px" />
          </CardButton>
        </>
      )}

      {Constants.WHOLESALERSETTINGS.code !== 'OE' && (
        <>
          <Spacer height="24px" />

          <H6>Active Faults</H6>
          <Card padding="0">
            <Lists items={[{ text: 'No active faults found' }]} />
          </Card>
        </>
      )}
    </ContentWrapper>
  )
})

export const Route = createFileRoute('/_authenticated/support/')({
  component: SupportPage,
})
